import React, {FC} from "react"
import {FormattedMessage} from "@irati/utils/lang"

import {H1, Body} from "@irati/ui/src/Typography"
import {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import Icon from "@irati/ui/src/Icon"
import {CategoryTypes} from "@irati/ui/src/experimental"
import {Container, Content} from "./styled"

interface Props {
  image?: string,
  title: string,
  description: string,
  link: string,
  ctaText?: string,
  icon?: string,
  type?: CategoryTypes,
  color?: string,
  onClick?: () => void
}

const Banner: FC<Props> = ({image, title, description, link, ctaText, icon, type, color, onClick}) => {
  return (
    <Container direction="column" justifyContent="space-around" image={image} marginTop={4}>
      <Content direction="row">
        <Flex marginRight={6}>{icon && <Icon icon={icon} size={120} />}</Flex>
        <div>
          <H1 color={color} marginBottom={1}>
            {title}
          </H1>
          <Body>{description}</Body>

          {type === CategoryTypes.External ? (
            <ButtonLink primary marginTop={2} href={link} target="_blank" onClick={onClick}>
              {ctaText}
            </ButtonLink>
          ) : (
            <ButtonRouterLink primary to={link} marginTop={2} onClick={onClick}>
              {ctaText || <FormattedMessage id="platform.banner.link.text" />}
            </ButtonRouterLink>
          )}
        </div>
      </Content>
    </Container>
  )
}

export default Banner
